import MyWorkWidget from './widgets/MyWorkWidget';
import AnnouncementsWidget from './widgets/AnnouncementsWidget';
import WeatherWidget from './widgets/WeatherWidget';
import CompanyLinksWidget from './widgets/CompanyLinksWidget';
import QuickActionsWidget from './widgets/QuickActionsWidget';
import WhatsNewWidget from './widgets/WhatsNewWidget';
import CompanyLicenseRenewalsWidget from './widgets/CompanyLicenseRenewalsWidget';

/**
 * widget_key → component. The server-side registry decides what EXISTS and who
 * may see it; this map only says how to draw it. A key with no component here
 * renders nothing, so the two can be deployed independently.
 */
export const WIDGET_COMPONENTS = {
  my_work: MyWorkWidget,
  announcements: AnnouncementsWidget,
  local_weather: WeatherWidget,
  company_links: CompanyLinksWidget,
  quick_actions: QuickActionsWidget,
  whats_new: WhatsNewWidget,
  company_license_renewals: CompanyLicenseRenewalsWidget,
};

/** Optional "open the full module" target per widget. */
export const WIDGET_MODULE_LINKS = {
  my_work: '/evaluations',
  announcements: '/announcements',
  company_links: '/announcements?tab=links',
  whats_new: '/whats-new',
  company_license_renewals: '/compliance/licenses',
};

/**
 * The count shown on a card's header, so a collapsed dashboard still tells you
 * what needs attention. `tone: 'urgent'` paints it red.
 */
export const badgeFor = (key, data) => {
  if (!data) return null;
  switch (key) {
    case 'my_work': {
      const n = data.total || 0;
      return n
        ? { text: `${n} pending`, tone: 'urgent' }
        : { text: 'All clear', tone: 'calm' };
    }
    case 'announcements': {
      const unread = data.unread || 0;
      if (unread) return { text: `${unread} new`, tone: 'accent' };
      const n = (data.items || []).length;
      return n ? { text: `${n}`, tone: 'muted' } : null;
    }
    case 'local_weather': {
      const alerts = (data.alerts || []).length;
      if (alerts) return { text: `${alerts} alert${alerts === 1 ? '' : 's'}`, tone: 'urgent' };
      const temp = data.current?.temperature_f ?? (data.forecast || [])[0]?.temperature;
      return temp != null ? { text: `${temp}°`, tone: 'muted' } : null;
    }
    case 'company_links':
    case 'quick_actions': {
      const n = (data.items || []).length;
      return n ? { text: `${n}`, tone: 'muted' } : null;
    }
    case 'whats_new':
      return data.version ? { text: data.version, tone: 'muted' } : null;
    case 'company_license_renewals': {
      const expired = data.expired || 0;
      if (expired) return { text: `${expired} expired`, tone: 'urgent' };
      const soon = data.soon || 0;
      return soon ? { text: `${soon} soon`, tone: 'accent' } : { text: 'All current', tone: 'calm' };
    }
    default:
      return null;
  }
};
